import { IChangePassword, IChangePasswordResponse } from 'Module/ChangePassword/Interface';
import Api from 'Shared/Services/Api/index';
import GetSystemAuthUtil from 'Shared/Utils/ConfigEnvironment/GetSystemAuth/index';

const setChangePasswordService = async (fields: IChangePassword, id?: string) => {
  return new Promise<IChangePasswordResponse>(async (resolve, reject) => {
    let regReturn: IChangePasswordResponse = {
      status: '200',
      message: '',
    };
    try {
      const _url = id ? `/changepassword/${id}` : '/changepassword';

      await Api.post(_url,
        {
          "systemauth": GetSystemAuthUtil(process.env.REACT_APP_ENVIRONMENT),
          "passwordcurrent": fields.passwordcurrent,
          "password": fields.password,
          "confirmpassword": fields.confirmpassword
        })
        .then(resp => {
          resolve(regReturn);
        })
        .catch(error => {
          console.log('ChangePassword.Service.SetChangePassword.error');
          console.log(error);
          let msgerror = error.stack ? error.stack : 'Ocorreu um erro!';
          if (error.response && error.response.data) {
            msgerror = error.response.data.msgErr;
          }
          if (error.response && error.response.result) {
            msgerror = error.response.result.msgErr;
          }

          regReturn.status = '400';
          regReturn.message = JSON.stringify(msgerror);
          regReturn.msgErro = JSON.stringify(error);
          reject(regReturn)
        });
    }
    catch (err) {
      console.log('ChangePassword.Service.SetChangePassword.err');
      console.log(err);

      let _msgError = 'Ocorreu um erro!';
      regReturn.status = '400';
      regReturn.message = _msgError;
      regReturn.msgErro = JSON.stringify(err);
      reject(regReturn)
    }
  });
}

export default setChangePasswordService;